
<div v-if="!elementIsHidden"
     :data-id="contentElement.client_id"
     :data-type="contentElement.content_type"
     :class="[contentElementClasses]"
     class="fds"
>
  <slot-array v-if="shouldShowLabel" :length="8">
    <template :slot="1">
      <column>
        <component :is="contentElement.labelTag" :class="contentElement.labelClass">
          {{contentElement.label_title}}
          <help-tooltip v-if="contentElement.help_text"
                        :text="contentElement.help_text"
                        :key="`${contentElement.client_id}-${contentElement.help_text}`"></help-tooltip>
        </component>
      </column>
    </template>
    <template :slot="2">

    </template>
  </slot-array>
  <component
    v-if="getComponentByType(contentElement.content_type)"
    :is="getComponentByType(contentElement.content_type)"
    :content-element="contentElement"
    :entry="entry"
    :is-in-edit-mode="isInEditMode"
    :showingAllAttachments="showingAllAttachments"
    :key="contentElement.client_id">
  </component>
  <slot-array :length="1">
    <template :slot="1">


    </template>
  </slot-array>
</div>
